import { Link } from 'react-router-dom';
import { FileTextOutlined } from '@ant-design/icons';
import { Highlight } from '@/shared/ui/Highlight';
import { formatName, formatDate } from '@/utils/search';
import type { SearchReport } from '@/models/search';
import styles from '../styles/ResultRow.module.css';

export const ReportRow = ({
  report,
  query,
}: {
  report: SearchReport;
  query: string;
}) => {
  const studyDate = formatDate(report.studyDate);
  const signedDate =
    report.status === 'FINAL' ? formatDate(report.signatureDate) : null;
  const path = report.uuid ? `/reports/${report.uuid}/preview` : '#';

  return (
    <Link to={path} className={styles.resultRow}>
      <div className={`${styles.resultIcon} ${styles.report}`}>
        <FileTextOutlined />
      </div>
      <div className={styles.resultContent}>
        <span className={styles.resultPrimary}>
          <Highlight
            text={formatName(report.patientFirstName, report.patientLastName)}
            query={query}
          />
          {report.status && (
            <span
              className={`${styles.tag} ${report.status === 'FINAL' ? styles.tagSuccess : styles.tagDefault}`}
            >
              {report.status}
            </span>
          )}
          {report.isAddendum && (
            <span className={`${styles.tag} ${styles.tagReport}`}>
              Addendum
            </span>
          )}
        </span>
        <span className={styles.resultSecondary}>
          {report.studyAccessionNumber && (
            <>
              ACC:{' '}
              <Highlight text={report.studyAccessionNumber} query={query} />
            </>
          )}
          {report.studyAccessionNumber && studyDate && ' · '}
          {studyDate && <>{studyDate}</>}
          {signedDate && <> · Signed: {signedDate}</>}
        </span>
      </div>
      <span className={`${styles.typeBadge} ${styles.report}`}>Report</span>
    </Link>
  );
};
